import { TextFieldElement, TextFieldElementProps } from 'react-hook-form-mui';

function Input(props: TextFieldElementProps) {
  return <TextFieldElement {...props} />;
}

export default Input;
